// extracted by mini-css-extract-plugin
module.exports = {"body":"EABDScriptingContentCard_body__2FmV0"};